import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSharedAccounts } from '../../hooks/marketplaces/allegro/accounts'
import { AlertTriangle, X } from 'lucide-react'
import { useState } from 'react'

export default function ReAuthBanner() {
  const { accounts } = useSharedAccounts()
  const [dismissed, setDismissed] = useState(false)
  const { t } = useTranslation('accounts')
  
  // Get accounts that need re-authentication
  const needsReauth = accounts?.filter(a => a.needs_reauth) || []
  
  // Don't show if no accounts need re-auth or banner was dismissed
  if (needsReauth.length === 0 || dismissed) {
    return null
  }
  
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 px-4 py-3 shadow-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AlertTriangle className="h-5 w-5 text-yellow-600 flex-shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-medium text-yellow-800">
              {needsReauth.length === 1 ? (
                t('reAuthBanner.requiresSingle', { name: needsReauth[0].nazwa_konta })
              ) : (
                t('reAuthBanner.requiresMultiple', { count: needsReauth.length })
              )}
            </p>
            <p className="text-xs text-yellow-700 mt-1">
              {t('reAuthBanner.subtitle')}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <Link
            to="/accounts"
            className="bg-yellow-600 hover:bg-yellow-700 text-white text-sm font-medium px-4 py-2 rounded transition-colors"
          >
            {t('reAuthBanner.reconnect')}
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="text-yellow-600 hover:text-yellow-700 p-1 rounded hover:bg-yellow-100 transition-colors"
            aria-label={t('reAuthBanner.dismiss')}
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
